module.exports = __webpack_public_path__ + "media/application/images/ui/icon-padlock-321223c7bfd4b3a33c128a22dd9b3d2f.png";